/* Parts VanMoof — theme interactions. Vanilla JS, geen dependencies. */
(function () {
  'use strict';

  /* ── Header: 'is-scrolled' na 60px + zweef onder de announcement-balk ── */
  var header = document.querySelector('[data-header]');
  var headerWrap = document.querySelector('.header-wrap');
  var announcement = document.querySelector('.announcement');
  if (header) {
    var onScroll = function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 60);
      // laat de pil onder de announcement-balk zweven zolang die in beeld is,
      // en schuif 'm naar boven zodra je eroverheen scrolt (anders dekt de pil de balk af)
      if (headerWrap) {
        var annH = announcement ? announcement.offsetHeight : 0;
        headerWrap.style.top = (y > annH ? 12 : annH + 10) + 'px';
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ── Nav-dropdowns: klik/toets naast hover (voor touch + toegankelijkheid) ── */
  document.querySelectorAll('[data-dropdown]').forEach(function (item) {
    var toggle = item.querySelector('[data-dropdown-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var open = item.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.querySelectorAll('[data-dropdown].open').forEach(function (other) {
        if (other !== item) { other.classList.remove('open'); other.querySelector('[data-dropdown-toggle]').setAttribute('aria-expanded', 'false'); }
      });
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) {
      document.querySelectorAll('[data-dropdown].open').forEach(function (item) {
        item.classList.remove('open');
        item.querySelector('[data-dropdown-toggle]').setAttribute('aria-expanded', 'false');
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-dropdown].open').forEach(function (i) { i.classList.remove('open'); });
  });

  /* ── Mobiel: submenu's uitklappen ── */
  document.querySelectorAll('[data-msub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.mobile-menu__group');
      var open = group.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── Mobiel menu ── */
  var menu = document.querySelector('[data-mobile-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('open', open);
    document.body.classList.toggle('menu-open', open);
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ── Hero parallax (mirror van GSAP yPercent) ── */
  var heroBg = document.querySelector('[data-hero-parallax]');
  if (heroBg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.pageYOffset, window.innerHeight);
        heroBg.style.transform = 'translateY(' + (y * 0.18) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ── Predictive search overlay ── */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  if (searchOverlay) {
    var searchInput = searchOverlay.querySelector('[data-search-input]');
    var searchResults = searchOverlay.querySelector('[data-search-results]');
    var searchTimer;

    function openSearch() {
      searchOverlay.classList.add('open');
      document.body.classList.add('menu-open');
      setTimeout(function () { searchInput.focus(); }, 60);
    }
    function closeSearch() {
      searchOverlay.classList.remove('open');
      document.body.classList.remove('menu-open');
    }
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
    document.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    searchOverlay.addEventListener('click', function (e) { if (e.target === searchOverlay) closeSearch(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { runPredictive(q); }, 220);
    });

    function runPredictive(q) {
      var url = window.Shopify.routes.root + 'search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,page'
        + '&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderPredictive(q, data.resources.results); })
        .catch(function () { searchResults.innerHTML = ''; });
    }

    function renderPredictive(q, res) {
      var html = '';
      var products = (res.products || []);
      var collections = (res.collections || []);
      var pages = (res.pages || []);

      if (!products.length && !collections.length && !pages.length) {
        searchResults.innerHTML = '<div class="search-results__empty">' + window.PVMStrings.noResults + '</div>';
        return;
      }
      if (products.length) {
        html += '<div class="search-results__group-label">' + window.PVMStrings.products + '</div>';
        products.forEach(function (p) {
          var img = p.featured_image ? p.featured_image.url : (p.image || '');
          html += '<a class="search-hit" href="' + p.url + '">'
            + (img ? '<span class="search-hit__thumb"><img src="' + img + '" alt=""></span>' : '<span class="search-hit__thumb"></span>')
            + '<span><span class="search-hit__title">' + p.title + '</span>'
            + (p.vendor ? '<span class="search-hit__meta">' + p.vendor + '</span>' : '')
            + '</span>'
            + (p.price ? '<span class="search-hit__price">' + money(parsePrice(p.price)) + '</span>' : '')
            + '</a>';
        });
      }
      if (collections.length) {
        html += '<div class="search-results__group-label">' + window.PVMStrings.collections + '</div>';
        collections.forEach(function (c) {
          html += '<a class="search-hit" href="' + c.url + '"><span><span class="search-hit__title">' + c.title + '</span></span></a>';
        });
      }
      if (pages.length) {
        html += '<div class="search-results__group-label">' + window.PVMStrings.pages + '</div>';
        pages.forEach(function (pg) {
          html += '<a class="search-hit" href="' + pg.url + '"><span><span class="search-hit__title">' + pg.title + '</span></span></a>';
        });
      }
      html += '<a class="search-results__all" href="' + window.Shopify.routes.root + 'search?q=' + encodeURIComponent(q) + '&type=product">'
        + window.PVMStrings.allResults + ' &rarr;</a>';
      searchResults.innerHTML = html;
    }
    // predictive API geeft prijs als string ("29.95") of nummer; normaliseer naar centen
    function parsePrice(v) {
      if (typeof v === 'number') return v;
      var n = parseFloat(String(v).replace(',', '.'));
      return isNaN(n) ? 0 : Math.round(n * 100);
    }
  }

  /* ── Collectie: mobiele filter-toggle ── */
  var filtersToggle = document.querySelector('[data-filters-toggle]');
  var filtersPanel = document.querySelector('[data-filters]');
  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', function () {
      var open = filtersPanel.classList.toggle('open');
      filtersToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.faq__item').classList.toggle('open');
    });
  });

  /* ── Quantity steppers ── */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ── Product: variant-selectie + galerij ── */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) initProduct(productForm);

  function initProduct(form) {
    var dataEl = document.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var groups = form.querySelectorAll('.variant-group');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var stockEl = document.querySelector('[data-stock]');
    var addBtn = form.querySelector('[data-add]');

    // Lees per optie-groep de gekozen waarde: <select> → value, knoppen → de
    // aangevinkte radio. (Alle radios delen data-option-index, dus we mogen niet
    // simpelweg over elk element itereren.)
    function chosenOptions() {
      var chosen = [];
      groups.forEach(function (g) {
        var select = g.querySelector('select[data-option-index]');
        if (select) { chosen[+select.dataset.optionIndex] = select.value; return; }
        var radio = g.querySelector('input[type="radio"]:checked');
        if (radio) { chosen[+radio.dataset.optionIndex] = radio.value; }
      });
      return chosen;
    }
    function currentVariant() {
      var chosen = chosenOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }
    function render() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatVariantPrice(v);
      if (stockEl) {
        var available = v.available;
        stockEl.textContent = available ? (window.PVMStrings.inStock) : (window.PVMStrings.soldOut);
        stockEl.classList.toggle('product__stock--out', !available);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? window.PVMStrings.addToCart : window.PVMStrings.soldOut;
      }
    }
    function formatVariantPrice(v) {
      var html = '<span class="price price--lg">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<span class="price price--lg"><del>' + money(v.compare_at_price) + '</del>' + money(v.price) + '</span>';
      }
      return html;
    }
    form.querySelectorAll('[data-option-index]').forEach(function (s) {
      s.addEventListener('change', function () {
        // segmented knoppen: sync de visuele 'is-selected' staat
        if (s.dataset.optionUi === 'buttons') {
          s.closest('.variant-group').querySelectorAll('.variant-option').forEach(function (o) {
            o.classList.toggle('is-selected', o.querySelector('input').checked);
          });
        }
        render();
      });
    });
    render();

    // galerij thumbs
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = document.querySelector('[data-main-image]');
        if (main) main.src = t.dataset.full;
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ── AJAX add-to-cart ── */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = window.PVMStrings.adding; }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(serialize(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () {
          toast(window.PVMStrings.added);
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
    });
  });

  function serialize(form) {
    var data = { items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] };
    var q = form.querySelector('[name="quantity"]');
    if (q) data.items[0].quantity = parseInt(q.value, 10) || 1;
    return data;
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  /* ── Toast ── */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.innerHTML = '<span class="toast__dot"></span><span data-toast-msg></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('[data-toast-msg]').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ── Money format — volledige Shopify formatMoney (alle placeholders) ── */
  function money(cents) {
    var format = window.PVMMoneyFormat || '&euro;{{amount_with_comma_separator}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var value = '';
    var token = (format.match(placeholder) || [null, 'amount'])[1];
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  // ── Taal/regio-kiezer (native <details>) ──────────────────────────────
  var locDetails = document.querySelectorAll('[data-loc-dd]');
  if (locDetails.length) {
    locDetails.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (!dd.open) return;
        // sluit andere open kiezers
        locDetails.forEach(function (other) { if (other !== dd) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-loc-dd]')) return;
      locDetails.forEach(function (dd) { dd.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') locDetails.forEach(function (dd) { dd.open = false; });
    });
  }

  window.PVM = { toast: toast, refreshCart: refreshCart };
})();
